<template>
  <v-container>
    <v-form ref="form" v-model="isFormValid" lazy-validation>
      <v-row>
        <v-col cols="12">
          <v-card class="px-7 mt-4 pt-7">
            <v-row>
              <v-col cols="12">
                <SimplePageHeader
                  v-if="!isEdit"
                  title="Add Business Entity"
                ></SimplePageHeader>
                <SimplePageHeader
                  title="Edit Business Entity"
                  v-else
                ></SimplePageHeader>
              </v-col>
            </v-row>
            <v-row class="pt-5 pb-5">
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Business Entity Name"
                  v-model="businessEntityName"
                  :rules="[Required('Business Entity Name')]"
                  validate-on-blur
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <ButtonsSubmitForm
        :isFormValid="isFormValid"
        @save="handleSaveBusinessEntity"
        @cancel="cancel"
      >
      </ButtonsSubmitForm>
    </v-form>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { businessEntitiesRoute } from '@/lib/constants/routes'
import { ButtonsSubmitForm } from '@/components/buttons'
import { SimplePageHeader } from '@/components/pageComponents'
import Required from '@/lib/formValidations/required'

export default {
  components: {
    ButtonsSubmitForm,
    SimplePageHeader
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousRoute = from
    })
  },
  data: () => ({
    isFormValid: false,
    previousRoute: null
  }),
  computed: {
    ...mapFields('businessEntity', [
      'businessEntityName'
    ]),
    id: {
      get () {
        return this.$route.params.id || null
      }
    },
    isEdit: {
      get () {
        return !!this.id
      }
    }
  },
  methods: {
    Required,
    ...mapActions('businessEntity', [
      'getBusinessEntity',
      'saveBusinessEntity',
      'clearBusinessEntity'
    ]),
    loadBusinessEntityData () {
      this.getBusinessEntity({ id: this.id })
    },
    async handleSaveBusinessEntity () {
      if (!this.$refs.form.validate()) return

      const response = await this.saveBusinessEntity()
      if (!response || !response.data) return

      if (this.previousRoute && this.previousRoute.name === businessEntitiesRoute.name) {
        this.$router.back()
        return
      }

      this.$router.push({ name: businessEntitiesRoute.name })
    },
    cancel () {
      if (this.previousRoute && this.previousRoute.name === businessEntitiesRoute.name) {
        this.$router.back()
        return
      }

      this.$router.push({ name: businessEntitiesRoute.name })
    }
  },
  mounted () {
    this.$refs.form.resetValidation()
    if (this.isEdit) {
      this.loadBusinessEntityData()
    } else {
      this.clearBusinessEntity()
    }
  }
}
</script>
